/**
 * Hermes Design Tokens - Animations
 * Purposeful motion that conveys speed and digital efficiency
 */

export const animations = {
  easing: {
    smooth: 'cubic-bezier(0.4, 0, 0.2, 1)',
    bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    gentle: 'cubic-bezier(0.25, 0.8, 0.25, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
  },
  duration: {
    fast: '150ms',
    normal: '250ms',
    slow: '400ms',
    slower: '600ms',
  },
};

export const keyframes = {
  fadeIn: `
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
  `,
  slideUp: `
    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `,
  slideDown: `
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `,
  scaleIn: `
    @keyframes scaleIn {
      from {
        opacity: 0;
        transform: scale(0.95);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
  `,
  shimmer: `
    @keyframes shimmer {
      0% {
        background-position: -1000px 0;
      }
      100% {
        background-position: 1000px 0;
      }
    }
  `,
};

/**
 * Common transition strings for convenience
 */
export const transitions = {
  default: `all ${animations.duration.normal} ${animations.easing.smooth}`,
  fast: `all ${animations.duration.fast} ${animations.easing.smooth}`,
  slow: `all ${animations.duration.slow} ${animations.easing.gentle}`,
  transform: `transform ${animations.duration.normal} ${animations.easing.smooth}`,
  color: `color ${animations.duration.fast} ${animations.easing.smooth}`,
};
